import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RestApi } from "src/app/shared/RestApi/restApi";
import { MatSnackBar } from "@angular/material/snack-bar";

interface UsersServiceInfo {
  statusMessage: any;
  error: boolean;
  data: any;

}

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(private spinner: NgxUiLoaderService, private http: HttpClient, private restAPI: RestApi, private snackBar: MatSnackBar) { }

  async updateService(updateObject) {

    this.spinner.start();

    let response = await this.http.put<UsersServiceInfo>(this.restAPI.UPADTE_USER_RECORD_URL, updateObject, { headers: this.headers }).toPromise();

    this.spinner.stop();

    this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

    return response;
  }

}